/* eslint-disable */
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from '@material-ui/core/ListItemText';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import profileImage from "assets/img/default-avatar.png";
import commonStyles from "assets/jss/common/common";
import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Box, Typography } from '@mui/material';
import colorStyle from 'assets/jss/common/colorStyle';
// nodejs library to set properties for components
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { logout } from "routes/Auth/Auth";
import SearchBox from 'components/Header/SearchBox'
import { useIsAuthenticated, useGetProfile } from 'hooks/userHook';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import WebTranslateText from "Utils/Translation/WebTranslateText";

const styles = (theme) => ({
  ...commonStyles,
  ...headerLinksStyle(theme),
})


function CollapseMenu({
  label,
  children
}, {
  label: string,
  children: any
}) {
  const [open, setOpen] = useState(false)

  return <>
    <ListItem button onClick={() => setOpen(!open)}>
      <ListItemText primary={label} />
      {open ? <ExpandLess /> : <ExpandMore />}
    </ListItem>
    <Divider />
    <Collapse in={open} timeout="auto" unmountOnExit>
      <div style={{ textIndent: '1rem' }}>
        {children}
      </div>
    </Collapse>
  </>
}
function HeaderLinks({ ...props }) {
  const { classes, dropdownHoverColor } = props;
  const [portfolioConsOpen, setPortfolioConsOpen] = useState(false)
  const isAuthenticated = useIsAuthenticated()
  const headerMode = useSelector((state: RootState) => state.appstate.HEADER_MODE)

  const profile = useGetProfile()
  const userId = profile?.id

  const isActive = (key) => {
    let routeName = props.current_url;
    if (routeName && routeName.indexOf(key) > -1) {
      return true
    }
    return false
  }
  const history = useHistory()
  const getListItem = (label, url, is_app_url = true, icon?: any) => {

    return (<React.Fragment>
      <ListItem onClick={() => {
        props.hideDrawer();
        if (is_app_url) {
          history.push(url)
        } else {
          window.open(url)
        }
      }} button>
        <Typography sx={{ padding: '0.25rem' }}>{label}</Typography><span style={{ marginLeft: '0.2rem' }}>{icon}</span>
      </ListItem>
    </React.Fragment>)
  }
  
  return (
    <List>
        {getListItem(<WebTranslateText text={'Home'} part="General" />, '/')}
        {getListItem(<WebTranslateText text={'ABOUT US'} part="General" />, '/about-us')}
        {getListItem(<WebTranslateText text={'Services'} part="Services" />, '/services')}
        <div style={{ marginLeft: '1rem' }}>{getListItem(<WebTranslateText text={'AI Investments'} part="General" />, '/ai-investments')}</div>
        <div style={{ marginLeft: '1rem' }}>{getListItem(<WebTranslateText text={'AI Analytics'} part="General" />, '/ai-analytics')}</div>
        {getListItem(<WebTranslateText text={'Contact'} part="General" />, '/contact')}

        <ListItem>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Button fullWidth color='info' onClick={e => { props.hideDrawer(); window.open('https://app.actelligent-capital.com/auth/login') }}>
              <WebTranslateText text={'Log In'} part="General" />
            </Button>
            <Button fullWidth color='success' onClick={e => { props.hideDrawer(); window.open('https://app.actelligent-capital.com/auth/signup') }}>
              <WebTranslateText text={'Sign Up'} part="General" />
            </Button>
          </div>
        </ListItem>
    </List>
  );
}

HeaderLinks.defaultProps = {
  hoverColor: "primary"
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ])
};

export default withStyles(styles)(HeaderLinks);